<template>
  <v-hover v-model="hover">
    <sn-shadow :shadow-depth="hideShadow ? null : 0">
      <v-expansion-panels
        :style="cardStyle"
        class="sn-expansion-panel"
        v-bind="effectiveBindings"
        data-cy="task-card"
        v-on="$listeners"
      >
        <slot />
      </v-expansion-panels>
    </sn-shadow>
  </v-hover>
</template>
<script>

import snShadow from '~/components/snui/v2/snShadow/snShadow'
import vuetifyOverrideMixin from '~/components/snui/v2/mixins/vuetifyOverrideMixin.vue'

export default {
  name: 'SnExpansionPanels',
  components: { snShadow },
  mixins: [vuetifyOverrideMixin],
  // v-expansion-panels uses 'change' instead of the default 'input' event to track model changes
  // See https://github.com/vuetifyjs/vuetify/blob/75404fb66e61d4b4d5b759506ac0d4c7a56a3755/packages/vuetify/src/mixins/selectable/index.ts#L23
  model: { prop: 'value', event: 'change' },
  props: {
    size: {
      type: String,
      required: false,
      default: 'small'
    },
    width: {
      type: String,
      required: false,
      default: 'auto'
    },
    expandable: {
      type: Boolean,
      required: false,
      default: true
    },
    hideShadow: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      hover: false,
      vuetifyOverrideMixin: {
        overriddenProps: {
          flat: true,
          accordion: true
        }
      }
    }
  },
  computed: {
    cardStyle () {
      const style = {}
      style['--header-min-height'] = this.cardHeight
      style['--content-width'] = this.width
      return style
    },
    cardHeight () {
      switch (this.size) {
        case 'large':
          return '172px'
        case 'medium':
          return '114px'
        case 'small':
          return '96px'
        case 'x-small':
          return '54px'
        default:
          return 'inherit'
      }
    },
    readOnly () {
      return { readonly: !this.expandable }
    },
    effectiveBindings () {
      return {
        ...this.vuetifyOverrideMixin.bindings,
        ...this.readOnly
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './app/javascript/assets/css/snui/_globalVariables.scss';

.vuetifycss .sn-expansion-panel,
.sn-expansion-panel{
  margin: auto;
  width: var(--content-width);
  max-width: var(--content-width);
}

</style>
